module.exports = __webpack_public_path__ + "img/phone.13b49ea2.svg";